
export class SheetCustomValue {
    presetId: string;
    fileName: string;
    sheetHeaderId: string;
    sheetFieldName: string;
    customValue: string;
}
